import { RpcService } from 'rpc';
import { DefinedRoots, TopicDef, ParentTree } from '../interfaces';

export interface IDitaBook extends RpcService {
	get_versions(params: { versionbase: string }): Promise<string[]>;
	get_latest_version(params: { versionbase: string }): Promise<string>;
	get_parenttree(param: { version: string; language: string }): Promise<ParentTree>;
	get_root(params: { rootname: string; version: string; language: string }): Promise<TopicDef>;
	get_topic_roots(params: { version: string; language: string }): Promise<DefinedRoots>;
	get_topic(params: { topicname: string; version: string; language: string }): Promise<TopicDef>;
	related_topics(params: { topicid: string; version: string; language: string }): Promise<string[]>;
	get_images(params: { version: string; language: string }): Promise<string[]>;
	quiz_list(): Promise<Record<string, string>>;
}

export const svc: IDitaBook = new RpcService({
	transport: 'WEBSOCKET',
	envelope: 'JSON-RPC-2.0',
	strictParameters: false,
	target: `${window.hcstatic.portal_url}/@@learningpath.rpc`,

	services: {
		get_versions: {
			parameters: [
				{
					name: 'versionbase',
					type: 'string',
					optional: false
				}
			]
		},
		get_latest_version: {
			parameters: [
				{
					name: 'versionbase',
					type: 'string',
					optional: false
				}
			]
		},
		get_parenttree: {
			parameters: [
				{
					name: 'version',
					type: 'string',
					optional: false
				},
				{
					name: 'language',
					type: 'string',
					optional: false
				}
			]
		},
		get_root: {
			parameters: [
				{
					name: 'rootname',
					type: 'string',
					optional: false
				},
				{
					name: 'version',
					type: 'string',
					optional: false
				},
				{
					name: 'language',
					type: 'string',
					optional: false
				}
			]
		},
		get_topic_roots: {
			parameters: [
				{
					name: 'version',
					type: 'string',
					optional: false
				},
				{
					name: 'language',
					type: 'string',
					optional: false
				}
			]
		},
		get_topic: {
			parameters: [
				{
					name: 'topicname',
					type: 'string',
					optional: false
				},
				{
					name: 'version',
					type: 'string',
					optional: false
				},
				{
					name: 'language',
					type: 'string',
					optional: false
				}
			]
		},
		related_topics: {
			parameters: [
				{
					name: 'topicid',
					type: 'string',
					optional: false
				},
				{
					name: 'version',
					type: 'string',
					optional: false
				},
				{
					name: 'language',
					type: 'string',
					optional: false
				}
			]
		},
		get_images: {
			parameters: [
				{
					name: 'version',
					type: 'string',
					optional: false
				},
				{
					name: 'language',
					type: 'string',
					optional: false
				}
			]
		},
		quiz_list: {
			parameters: []
		}
	}
}) as IDitaBook;

export default svc;
